module.exports = __webpack_public_path__ + "img/FAAS_Complete_Business_Combination_PR_4.2.24_bahasaRevFN_-_revLgl.28aa1cc2.jpg";